import { Typography, Space, Row, Col, Button, Image, theme } from "antd";
import { FallbackProps } from "react-error-boundary";
import useErrorBoundary from "./useErrorBoundary";
import Crash from "::assets/icons/crash.png";

const { Text, Title } = Typography;
const { useToken } = theme;

const FallbackComponent = ({ error, resetErrorBoundary }: FallbackProps) => {
	const { handleTryAgain, isDev } = useErrorBoundary({
		error,
		resetErrorBoundary,
	});
	const {
		token: { colorBgContainer },
	} = useToken();

	return (
		<Row
			align="middle"
			justify="center"
			style={{ height: "100vh", background: colorBgContainer }}
		>
			<Col>
				<Space direction="vertical" align="center">
					<Image src={Crash} preview={false} alt="Crash" placeholder="Crash" />
					<Title level={3}>Oops! Seems like we broke</Title>
					<Title style={{ margin: 0 }} level={4}>
						Please refresh the page or try again later
					</Title>
					{isDev && (
						<Space direction="vertical" align="center">
							<Title level={2}>
								We should have a logging service to log more useful info about
								the errors
							</Title>
							<Text>{error.message}</Text>
							<Text>{error.stack}</Text>
						</Space>
					)}
					<Button onClick={handleTryAgain} type="primary">
						Try again
					</Button>
				</Space>
			</Col>
		</Row>
	);
};

export default FallbackComponent;
